export default __webpack_public_path__ + "e0b336c65b079e9cd8f3d7919b68b0a3.svg";